module.exports = __webpack_public_path__ + "img/amex.257beab7.png";